export const MAIN_CONTAINER_HEIGHT = 1091;
export const MODAL_ANIMATION_DURATION = 300;
